import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap'; // Import Modal
import CustomButton from './CustomButton/CustomButton';

// Import your servicesCards data
import servicesCards from '../data/servicesCards'; // Adjust this path if necessary based on your folder structure

const ServicesSection = () => {
    const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  const [showModal, setShowModal] = useState(false);
  const [modalBodyContent, setModalBodyContent] = useState(null); // State to hold the JSX for the modal body

  // Function to handle image clicks and set modal content
  const handleImageClick = (modalBody) => {
    setModalBodyContent(modalBody);
    setShowModal(true);
  };

  // Function to close the modal
  const handleClose = () => {
    setShowModal(false);
    setModalBodyContent(null); // Clear content when modal closes
  };

  return (
    <section className="py-3">
      <Container fluid>
        {/* Title */}
        <Row className="justify-content-center mb-5">
          <Col xs="auto">
            <h2 className="font-bold text-black text-uppercase pt-5">
              Services
            </h2>
          </Col>
        </Row>
        <Row className="g-4 justify-content-center mb-4">
          <Col xs={10} md={3} lg={3}>
            {/* Brand Strategy Card - Clickable */}
            <div
              className="position-relative ratio ratio-4x3 img-radius overflow-hidden"
              style={{ cursor: 'pointer' }} // Indicate it's clickable
              onClick={() => handleImageClick(servicesCards[0].modalBody)} // Link to the first modalBody
            >
              <img
                src={`${awsImageBaseUrl}images/brand_strategy.jpg`}
                alt="Brand Strategy"
                className="w-100 h-100 object-fit-cover"
                loading="lazy"
              />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-25 overlay-gradient-bottom"></div>
              <div className="position-absolute top-50 start-0 translate-middle-y ps-3 text-white text-start">
                <h5 className="font-bold fs-5 pt-3">Brand<br />Strategy</h5>
              </div>
            </div>
          </Col>

          <Col xs={10} md={3} lg={3}>
            {/* Naming & Innovation Card - Clickable */}
            <div
              className="position-relative ratio ratio-4x3 img-radius overflow-hidden"
              style={{ cursor: 'pointer' }} // Indicate it's clickable
              onClick={() => handleImageClick(servicesCards[1].modalBody)} // Link to the second modalBody
            >
              <img
                src={`${awsImageBaseUrl}images/name_innovation.png`}
                alt="Naming & Innovation"
                className="w-100 h-100 object-fit-cover"
                loading="lazy"
              />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-25 overlay-gradient-bottom"></div>
              <div className="position-absolute top-50 start-0 translate-middle-y ps-3 text-white text-start">
                <h5 className="font-bold fs-5 pt-3">Naming<br />& Innovation</h5>
              </div>
            </div>
          </Col>
           <Col xs={10} md={3} lg={3}>
            {/* Digital Design Card - Clickable */}
            <div
              className="position-relative ratio ratio-4x3  img-radius overflow-hidden"
              style={{ cursor: 'pointer' }} // Indicate it's clickable
              onClick={() => handleImageClick(servicesCards[2].modalBody)} // Link to the third modalBody
            >
              <img
                src={`${awsImageBaseUrl}images/PharmaceuticalServices.jpeg`}
                alt="Pharmaceutical Services"
                className="w-100 h-100 object-fit-cover"
                loading="lazy"
              />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-25 overlay-gradient-bottom"></div>
              <div className="position-absolute top-50 start-0 translate-middle-y ps-3 text-white text-start">
                <h5 className="font-bold fs-5 pt-3">Pharmaceutical <br />Services</h5>
              </div>
            </div>
          </Col>
        </Row>

        {/* Bottom Wide Card */}
        <Row className="justify-content-center">

        </Row>

        {/* CTA Button */}
        <Row className="justify-content-center mt-5">
          <Col xs="auto">
            <CustomButton
              label="EXPLORE OUR SERVICES"
              variant="red"
              size="small"
              href="/what-we-do"
            />
          </Col>
        </Row>

        {/* Modal Component */}
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          size="lg"
          contentClassName="bg-black text-white position-relative text-sm img-radius"
        >
          <Modal.Header className="border-0 px-5">
            <button
              type="button"
              onClick={handleClose}
              className="btn position-absolute top-0 end-0"
              style={{ fontSize: '3rem', color: 'red', background: 'none', border: 'none', marginTop:'-21px' }}
              aria-label="Close"
            >
              &times;
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  {/* Display the modal body content */}
                  {modalBodyContent || "No content available"}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

export default ServicesSection;